// Lead Agent chat-surface analytics events (RET-1010 follow-up).
//
// RET-1010 §1.6 deferred the handoff-reason picker to a separate design ticket.
// This module captures the events emitted by that picker and is the home for
// future chat-surface Lead Agent signals (escalation thumbs up/down, lead-lost
// intercept, etc.). Naming follows the `front.leadagent.chat.*` convention
// already in use for HANDOFF_TAKEN (defined module-locally in
// AutoRespondToggle.hook.ts so the smallest-possible diff lands first; that
// const moves here when a future PR adds neighbouring events).

export const LEADAGENT_CHAT_EVENTS = {
  HANDOFF_REASON_MODAL_SHOWN:
    'front.leadagent.chat.handoff_reason.modal_shown',
  HANDOFF_REASON_SUBMITTED:
    'front.leadagent.chat.handoff_reason.submitted',
  HANDOFF_REASON_SKIPPED:
    'front.leadagent.chat.handoff_reason.skipped',
  HANDOFF_REASON_DISMISSED:
    'front.leadagent.chat.handoff_reason.dismissed',
} as const;

// Which deactivation surface fired the modal. Per-chat is the MessageBar
// "Tomar control" pill + AIResponsePreview switch; smart-config is the
// ConfigHeader 3-dot menu → "Desactivar" in /leadbot/smart-config. The two
// surfaces share the same modal and frequency gate but capture semantically
// different intent (one chat vs. the whole workspace), so dashboards should
// always slice on `source` before drawing conclusions about category mix.
//
// V2 (RET-1069) adds an `entry_point` sub-dimension carried in the event
// payload (see tHandoffReasonEntryPoint in handoffReasonOptions.types.ts):
// per_chat decomposes into 'tomar_control' vs 'apagar_bot_chat'; smart_config
// is always 'desactivar_workspace'. `tHandoffReasonAskedVia` (V1's
// 'always_first_14d' | 'sampled') is removed — V2 uses per-entry-point
// cooldown windows, not adoption-phase sampling.
export type tHandoffReasonSource = 'per_chat' | 'smart_config';
